import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import detailsTable from "./Plugin/detailsTable.vue"
import { domainName, processApi } from "../../../../utility/index";
import axios from 'axios'

export default {
    components: { iTable, IPagination, detailsTable },
    data() {
        return {
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                MaintainTime: [],
                materialName: '',
                projectId: [],
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "serialNumber",
                    label: this.$t('VehicleManagement.serialNumber'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('common.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "carWorkTime",
                    label: this.$t('VehicleManagement.carWorkTime'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "operateUser",
                    label: this.$t('VehicleManagement.serialPerson'),
                    align: "center",
                    width: "120px"
                },

                {
                    prop: "operateTime",
                    label: this.$t('VehicleManagement.serialTime'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "remarks",
                    label: this.$t('common.remark'),
                    align: "center",

                },
                {
                    prop: "peopleCost",
                    label: this.$t('VehicleManagement.peopleCost'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "materialCost",
                    label: this.$t('VehicleManagement.materialCost'),
                    align: "center",
                    width: "120px"
                }
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        isBtn: "MAINTENANCEORDER_DETAIL",
                        method: (index, row) => {
                            console.log(index.row)
                            this.dialogOperateVisible = true
                            this.queryDetails()
                            // this.id = row.id
                            this.operateList = row
                        }
                    },
                    {
                        id: '2',
                        show: true,
                        icon: 'iconfont iconxiazai1',
                        plain: true,
                        disabled: false,
                        isBtn: "MAINTENANCEORDER_DETAIL",
                        method: (index, row) => {
                            if (domainName) {
                                if (domainName.split(':')[0] !== 'localhost') {
                                    let url = `https://${domainName}/v1/getExportExcel/exportMaterialData?serialNumber=${row.serialNumber}`
                                    location.href = url
                                } else {
                                    let host = 'localhost:8080'
                                    let url = `https://${host}/v1/getExportExcel/exportMaterialData?serialNumber=${row.serialNumber}`
                                    location.href = url
                                }
                            }

                        }
                    }
                ],
            },
            // id: '',
            operateList: '',
            dialogOperateVisible: false,
            currentPage: 1,
            pageSize: 10,
            total: 1,
            selected: [],
            orgId: '',
            OperateForm: {
                requestSerialNumber: '',
                carId: '',
                carWorkTime: '',
                operateUser: '',
                operateTime: '',
                remarks: '',
                peopleCost: '',
                materialCost: '',
                filePath: '',
                maintainPropose: ''
            },
            OperateLabelWidth: '126px',
            FileOperateList: [],
            processImg: processApi,
            dialogFileOperateVisible: false,
            imageOperateUrl: '',
            activeOperateName: 'first',

            options: [],
            tableData: [],
        }
    },
    created() {
        this.getTreeChange()
    },
    methods: {
        handleChange(value) {
            console.log(value);
        },
        getTreeChange() {
            this.$store.dispatch('MaintenanceProgram/GET_SELECTTREEFORMPROJECT', {}).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.options = res.data.data
                    }
                }
            }).catch(err => { })
        },
        getOrderList() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.MaintainTime) {
                if (this.formInline.MaintainTime.length > 0) {
                    startTime = this.formInline.MaintainTime[0]
                    endTime = this.formInline.MaintainTime[1]
                }
            }
            let param = {
                orgId: this.orgId,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                materialName: this.formInline.materialName,
                projectId: this.formInline.projectId[1],
                startTime: startTime,
                endTime: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('MaintenanceManagement/GET_QUERYORDERLIST', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getOrderList()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                MaintainTime: [],
                materialName: '',
                projectId: [],
            }
            this.getOrderList()
        },
        closeOperateDia() {
            this.dialogOperateVisible = false
        },
        handleOperateClick(event) {
            this.activeOperateName = event.name
            if (this.activeOperateName == 'first') {
                this.queryDetails()
            } else if (this.activeOperateName == 'second') {
                this.queryDetails()
            } else {
                this.$refs.detailTable.id = this.operateList.id
                this.$refs.detailTable.getDetailList()
            }

        },
        queryDetails() {
            this.$nextTick(() => {
                this.OperateForm = {
                    // type: this.operateList.type,
                    requestSerialNumber: this.operateList.serialNumber,
                    carId: this.operateList.carId,
                    carWorkTime: this.operateList.carWorkTime,
                    operateUser: this.operateList.operateUser,
                    operateTime: this.operateList.operateTime,
                    remarks: this.operateList.remarks,
                    peopleCost: this.operateList.peopleCost,
                    materialCost: this.operateList.materialCost,
                    filePath: this.operateList.filePath,
                    maintainPropose: this.operateList.maintainPropose
                }
                // this.FileOperateList = [];
                // const arr = this.operateList.filePath.split(',')
                // arr.forEach(filePath => {
                //     this.FileOperateList.push({
                //         url: filePath,
                //     });
                // });
                this.tableData = this.operateList.maintainProject
                this.tableData.map(item => {
                    item.projectOption = String(item.projectOption)
                })
            })
        },
        previewPdf() {
            window.open(this.operateList.filePath, '_blank');
        },
        indexMethod(index) {
            return index + 1;
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            let columnArr = [0]
            let projectbArr = [];
            for (let k in this.tableData) {
                projectbArr.push(this.tableData[k].project)
            }
            let obj = {}
            for (let i = 0; i < projectbArr.length; i++) {
                if (obj[projectbArr[i]] == undefined) {
                    obj[projectbArr[i]] = 1
                } else {
                    obj[projectbArr[i]]++
                }
            }
            let spanArr = [];
            let doneArr = []
            for (let i = 0; i < projectbArr.length; i++) {
                if (doneArr.includes(projectbArr[i])) {
                    spanArr.push(0)
                } else {
                    spanArr.push(obj[projectbArr[i]])
                    doneArr.push(projectbArr[i])
                }
            }
            if (columnArr.includes(columnIndex)) {
                for (let i = 0; i < spanArr.length; i++) {
                    if (rowIndex == i) {
                        return {
                            rowspan: spanArr[i],
                            colspan: 1
                        }
                    }
                }
            }
        },
        // changeRadio(index, row) {
        //     this.tableData.map(item => {
        //         if (item.projectName == row.projectName) {
        //             row.projectOption = index
        //         }
        //     })
        //     let arr = []
        //     arr.push({
        //         projectId: row.id,
        //         projectOption: row.projectOption
        //     })
        //     this.maintainProject = arr.concat(this.maintainProject)
        // },
        handleOperatePictureCardPreview(file) {
            this.imageOperateUrl = file.url;
            this.dialogFileOperateVisible = true;
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getOrderList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}